import { IconProps } from "@/data/types"

export default function ArrowRightIcon({ width=24, height=24, color='#A58760', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.39342 10.0004L22.6066 9.9994M22.6066 9.9994L13.9883 1.38195M22.6066 9.9994L13.9892 18.6177" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  )
}